import { Outlet } from 'react-router-dom';
import AppSidebar from '@/components/AppSidebar';
import AppHeader from '@/components/AppHeader';
import BuiltByFluid from '@/components/BuiltByFluid';

export default function AppLayout() {
  return (
    <div className="min-h-screen flex bg-ink-950 text-ink-50">
      <AppSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <AppHeader />
        <main className="flex-1 px-4 lg:px-8 py-6 max-w-6xl w-full mx-auto">
          <Outlet />
        </main>
        <footer className="border-t border-ink-700 px-4 lg:px-8 py-4 text-xs text-ink-500 flex items-center justify-between">
          <span>Non-custodial · TOTP-gated</span>
          <BuiltByFluid size="sm" variant="badge" />
        </footer>
      </div>
    </div>
  );
}
